import Lectures from './lectures'

export default Lectures
